import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import locizeBackend from 'i18next-locize-backend';
import {
  LOCIZE_VERSION,
  LOCIZE_API_KEY,
  LOCIZE_PROJECT_ID,
} from 'constants/config';

i18n.use(locizeBackend).use(initReactI18next); // passes i18n down to react-i18next

if (!i18n.isInitialized && !global.IS_SERVER) {
  i18n.use(detector);
  i18n.init({
    debug: false,
    saveMissing: !!LOCIZE_API_KEY && process.env.NODE_ENV === 'production',
    saveMissingTo: 'fallback',
    keySeparator: false,
    fallbackLng: 'en',
    lng: window.initialLanguage,
    load: 'languageOnly',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      projectId: LOCIZE_PROJECT_ID,
      apiKey: LOCIZE_API_KEY,
      version: LOCIZE_VERSION,
      referenceLng: 'en',
      allowedAddOrUpdateHosts: ['localhost', 'app-qa.textinchurch.com'],
      // loadPath: '/locales/{{projectId}}/{{version}}/{{lng}}/{{ns}}',
      // addPath: '/locales/{{projectId}}/{{version}}/{{lng}}/{{ns}}',
    },
    react: {
      useSuspense: true,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'p'],
    },
  });
}

export default i18n;
